import * as React from "react"
import { DigitsButton } from "@digits-shared/DesignSystem/Button"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@digits-shared/DesignSystem/Popovers/Popover"
import { DigitsTooltip } from "@digits-shared/DesignSystem/Tooltip"
import { styled } from "styled-components"

/*
  STYLES
*/

const Content = styled(PopoverContent)`
  padding: 0;
`

/*
  INTERFACES
*/

interface DisplayOptionsProps {
  title: string
  activeCount?: number
  IconElement: React.ElementType
  ActiveIconElement?: React.ElementType
  className?: string
  children?: React.ReactNode
}

/*
  COMPONENTS
*/

export const DisplayOptionsSection: React.FC<DisplayOptionsProps> = ({
  title,
  activeCount = 0,
  IconElement,
  ActiveIconElement,
  className,
  children,
}) => (
  <Popover>
    <DigitsTooltip content={title}>
      <PopoverTrigger asChild>
        <DigitsButton
          $circle
          className={className}
          $variant="ghost-dark"
          size="medium"
          $solidIcon={!!activeCount}
        >
          {!!ActiveIconElement && !!activeCount ? <ActiveIconElement /> : <IconElement />}
        </DigitsButton>
      </PopoverTrigger>
    </DigitsTooltip>

    <Content closeButtonSize="default" showCloseButton={!activeCount}>
      {children}
    </Content>
  </Popover>
)
